var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-stepper",
        {
          staticClass: "problem-edit",
          attrs: { value: _vm.step, "non-linear": "", width: "100%" },
          on: { change: _vm.gotoStepNumber },
        },
        [
          _c(
            "v-stepper-header",
            [
              _vm._l(_vm.steps, function (stepData) {
                return [
                  _c(
                    "v-stepper-step",
                    {
                      key: "s" + stepData.code,
                      attrs: {
                        editable: _vm.isStepEditable(stepData),
                        complete: _vm.isStepFinished(stepData),
                        step: stepData.step,
                      },
                    },
                    [_vm._v(_vm._s(stepData.title))]
                  ),
                  _c("v-divider", { key: "d" + stepData.code }),
                ]
              }),
            ],
            2
          ),
          _c(
            "v-stepper-items",
            [
              _c(
                "v-stepper-content",
                { staticClass: "pa-0", attrs: { step: "1" } },
                [
                  _c("steps-form", {
                    attrs: { editState: _vm.editState },
                    on: { next_step: _vm.gotoNextStep, list: _vm.gotoList },
                    model: {
                      value: _vm.item,
                      callback: function ($$v) {
                        _vm.item = $$v
                      },
                      expression: "item",
                    },
                  }),
                ],
                1
              ),
              _vm.item && _vm.item.type === "wells"
                ? _c(
                    "v-stepper-content",
                    { attrs: { step: "2" } },
                    [
                      _vm.step === 2
                        ? _c("adapt-settings", {
                            attrs: { "task-type": "wells" },
                            model: {
                              value: _vm.wellsTask,
                              callback: function ($$v) {
                                _vm.wellsTask = $$v
                              },
                              expression: "wellsTask",
                            },
                          })
                        : _vm._e(),
                      _vm.wellsTask &&
                      _vm.wellsTask.id &&
                      _vm.wellsTask.status === "finished"
                        ? _c(
                            "v-btn",
                            {
                              staticClass: "mt-4",
                              attrs: { large: "", color: "primary" },
                              on: { click: _vm.gotoNextStep },
                            },
                            [_vm._v("Посмотреть результаты")]
                          )
                        : _vm.wellsTask &&
                          _vm.wellsTask.id &&
                          _vm.wellsTask.status === "error"
                        ? _c(
                            "v-btn",
                            {
                              staticClass: "mt-4",
                              attrs: { large: "", color: "primary" },
                              on: { click: _vm.saveTaskAndGotoNextStep },
                            },
                            [_vm._v("Обновить параметры и перезапустить")]
                          )
                        : _c(
                            "v-btn",
                            {
                              staticClass: "mt-4",
                              attrs: { large: "", color: "primary" },
                              on: { click: _vm.saveTaskAndGotoNextStep },
                            },
                            [_vm._v("Далее")]
                          ),
                    ],
                    1
                  )
                : _c(
                    "v-stepper-content",
                    { attrs: { step: "2" } },
                    [
                      _vm.step === 2
                        ? _c("adapt-settings", {
                            attrs: { "task-type": "optimize" },
                            model: {
                              value: _vm.task,
                              callback: function ($$v) {
                                _vm.task = $$v
                              },
                              expression: "task",
                            },
                          })
                        : _vm._e(),
                      _vm.task && _vm.task.id && _vm.task.status === "finished"
                        ? _c(
                            "v-btn",
                            {
                              staticClass: "mt-4",
                              attrs: { large: "", color: "primary" },
                              on: { click: _vm.gotoNextStep },
                            },
                            [_vm._v("Посмотреть результаты")]
                          )
                        : _vm.task && _vm.task.id && _vm.task.status === "error"
                        ? _c(
                            "v-btn",
                            {
                              staticClass: "mt-4",
                              attrs: { large: "", color: "primary" },
                              on: { click: _vm.saveTaskAndGotoNextStep },
                            },
                            [_vm._v("Обновить параметры и перезапустить")]
                          )
                        : _c(
                            "v-btn",
                            {
                              staticClass: "mt-4",
                              attrs: { large: "", color: "primary" },
                              on: { click: _vm.saveTaskAndGotoNextStep },
                            },
                            [_vm._v("Далее")]
                          ),
                    ],
                    1
                  ),
              _vm.item && _vm.item.type === "wells"
                ? _c(
                    "v-stepper-content",
                    { attrs: { step: "3" } },
                    [
                      _vm.wellsTaskFinished
                        ? _c("adapt-result", {
                            attrs: { item: _vm.item, task: _vm.wellsTask },
                            on: { predict: _vm.gotoNextStep },
                          })
                        : _c("task-progress", {
                            attrs: {
                              task: _vm.wellsTask,
                              visible: _vm.step === 3,
                            },
                          }),
                    ],
                    1
                  )
                : _c(
                    "v-stepper-content",
                    { attrs: { step: "3" } },
                    [
                      _vm.taskFinished && _vm.step === 3
                        ? _c("adapt-result", {
                            attrs: { item: _vm.item, task: _vm.task },
                            on: { predict: _vm.gotoNextStep },
                          })
                        : _c("task-progress", {
                            attrs: { task: _vm.task, visible: _vm.step === 3 },
                          }),
                    ],
                    1
                  ),
              _vm.item && _vm.item.type === "wells"
                ? _c(
                    "v-stepper-content",
                    { attrs: { step: "4" } },
                    [
                      _vm.predictTaskFinished && _vm.step === 4
                        ? _c("adapt-result", {
                            attrs: {
                              item: _vm.item,
                              task: _vm.predictTask,
                              "optimize-task": _vm.wellsTask,
                            },
                          })
                        : _vm.predictTask && _vm.predictTask.id
                        ? _c("task-progress", {
                            attrs: {
                              task: _vm.predictTask,
                              visible: _vm.step === 4,
                            },
                          })
                        : _c("predict-settings", {
                            model: {
                              value: _vm.predictTask,
                              callback: function ($$v) {
                                _vm.predictTask = $$v
                              },
                              expression: "predictTask",
                            },
                          }),
                      !(_vm.predictTask && _vm.predictTask.id)
                        ? _c(
                            "v-btn",
                            {
                              staticClass: "mt-4",
                              attrs: { large: "", color: "primary" },
                              on: { click: _vm.savePredictTask },
                            },
                            [_vm._v("Далее")]
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _c(
                    "v-stepper-content",
                    { attrs: { step: "4" } },
                    [
                      _vm.predictTaskFinished && _vm.step === 4
                        ? _c("adapt-result", {
                            attrs: {
                              item: _vm.item,
                              task: _vm.predictTask,
                              "optimize-task": _vm.task,
                            },
                          })
                        : _vm.predictTask && _vm.predictTask.id
                        ? _c("task-progress", {
                            attrs: {
                              task: _vm.predictTask,
                              visible: _vm.step === 4,
                            },
                          })
                        : _c("predict-settings", {
                            model: {
                              value: _vm.predictTask,
                              callback: function ($$v) {
                                _vm.predictTask = $$v
                              },
                              expression: "predictTask",
                            },
                          }),
                      !(_vm.predictTask && _vm.predictTask.id)
                        ? _c(
                            "v-btn",
                            {
                              staticClass: "mt-4",
                              attrs: { large: "", color: "primary" },
                              on: { click: _vm.savePredictTask },
                            },
                            [_vm._v("Далее")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }